<div class="d-flex justify-content-start align-items-center" style="gap: 10px; padding: 15px;">
    <button class="cancel-btn" type="button" (click)="onCancel()">Cancel</button>
    <button type="submit" (click)="submitForm()" class="submit-btn" [disabled]="form.invalid || isSending"
        [ngClass]="{'disabled': form.invalid || isSending}">
        {{isNew?"Send For Approval": "Update"}}
    </button>
    <div class="spinner-container" *ngIf="isSending">
        <mat-spinner></mat-spinner>
    </div>
</div>